module.exports = __webpack_public_path__ + "static/jung-ba8bb1370615aaa980a1e21b9d35c5a5.jpg";